//引入axios
import axios from 'axios'
import qs from 'qs'

import {
    baseUrl
} from './url.js'
import {
    getLang
} from './language'

let cancel, promiseArr = {}
const CancelToken = axios.CancelToken;
//请求拦截器
axios.interceptors.request.use(config => {
    //发起请求时，取消掉当前正在进行的相同请求
    if (promiseArr[config.url]) {
        promiseArr[config.url]('操作取消')
        promiseArr[config.url] = cancel
    } else {
        promiseArr[config.url] = cancel
    }
    return config
}, error => {
    return Promise.reject(error)
})

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error)
})

axios.defaults.baseURL = baseUrl
//设置默认请求头
axios.defaults.headers = {
    'Accept': 'application/json'
}
axios.defaults.timeout = 10000

export default (url = '', data = {}, type = 'GET', headers) => {
    type = type.toUpperCase();
    
    // console.log(data)
    return new Promise((resolve, reject) => {
        if (type == 'GET') {
            data.language = getLang('LOCAL') ? getLang('LOCAL') : '1';
            axios({
                method: 'get',
                url,
                params: data,
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res.data)
            })
        } else if (type == 'POST') {
            data.language = getLang('LOCAL') ? getLang('LOCAL') : '1';
            axios({
                method: 'post',
                url,
                data: qs.stringify(data),
                headers: headers? headers :{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res.data)
            })
        } else if (type == 'INPUT') {
            axios({
                method: 'post',
                url,
                data: data,
                headers: headers
            }).then(res => {
                resolve(res.data)
            })
        }
    })
}